module.exports = __webpack_public_path__ + "img/48_18.7fae51ea.png";